import { render, staticRenderFns } from "./BankingInfo.vue?vue&type=template&id=08232cc2&scoped=true"
import script from "./BankingInfo.vue?vue&type=script&lang=js"
export * from "./BankingInfo.vue?vue&type=script&lang=js"
import style0 from "./BankingInfo.vue?vue&type=style&index=0&id=08232cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08232cc2",
  null
  
)

export default component.exports